import React from 'react'
import TagV2 from '@SonarCX/components/molecules/EHAccordion/TagBlockV2/TagV2'

import TagPreviewModal from '@SonarCX/components/atoms/TagsPreviewModal'

import useStyles from './styles'

interface TagProps {
  tags: string[]
}

const Tag: React.FC<TagProps> = ({ tags = [] }) => {
  const [shouldShowTagPreview, setShouldShowTagPreview] = React.useState(false)
  const [shouldCheckClose, setShouldCheckClose] = React.useState(false)
  const tagsHovertime = React.useRef(null)
  const tagsRef = React.useRef(null)

  const tagsToRender = React.useMemo(() => [...tags].slice(0, 2), [tags])
  const remainingTags = React.useMemo(() => [...tags].slice(2), [tags])

  const classes = useStyles()

  const handleEnter = React.useCallback(() => {
    clearTimeout(tagsHovertime.current)
    setShouldCheckClose(false)
    tagsHovertime.current = setTimeout(() => setShouldShowTagPreview(true), 500)
  }, [setShouldShowTagPreview])

  const handleLeave = React.useCallback(() => {
    clearTimeout(tagsHovertime.current)
    tagsHovertime.current = setTimeout(() => {
      setShouldCheckClose(true)
    }, 250)
  }, [])

  const handleHideTagsPreview = React.useCallback(() => {
    setShouldShowTagPreview(false)
    setShouldCheckClose(false)
  }, [])

  const halt = React.useCallback(e => {
    e.stopPropagation()
    e.preventDefault()
  }, [])

  // reset due timeout conflicts
  React.useEffect(() => {
    if (!shouldShowTagPreview && shouldCheckClose) {
      setShouldCheckClose(false)
    }
  }, [shouldShowTagPreview, shouldCheckClose])

  return (
    <div className={classes.root}>
      {tagsToRender.map((tag, index) => (
        <TagV2 key={`cell-tag-${tag}-${index}`} hideIcon tag={tag} />
      ))}
      {remainingTags.length > 0 && (
        <div
          ref={tagsRef}
          className={classes.extraTagsRoot}
          onMouseEnter={handleEnter}
          onMouseLeave={handleLeave}
          onClick={halt}
        >
          {remainingTags.length}+
        </div>
      )}

      {shouldShowTagPreview && (
        <TagPreviewModal
          onClose={handleHideTagsPreview}
          parentRef={tagsRef}
          tags={remainingTags}
          shouldCheckClose={shouldCheckClose}
        />
      )}
    </div>
  )
}

export default React.memo(Tag)
